module.exports = __webpack_public_path__ + "img/gwgl_bg.4bbec957.png";